import { render, staticRenderFns } from "./ProductEffective.vue?vue&type=template&id=ff403f9a"
import script from "./ProductEffective.vue?vue&type=script&lang=js"
export * from "./ProductEffective.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports